export default __webpack_public_path__ + "static/media/nike.5774deb6.jpg";